// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1dqoglyw{border-style:none}._16jlidpf{flex-grow:0}
._19bvze3t{padding-left:var(--ds-space-0,0)}
._1bah1h6o{justify-content:center}
._1bsb1tcg{width:24px}
._1e0c1txw{display:flex}
._1o9zidpf{flex-shrink:0}
._4cvr1h6o{align-items:center}
._4t3i1tcg{height:24px}
._80omtlke{cursor:pointer}
._ca0qze3t{padding-top:var(--ds-space-0,0)}
._i0dl1wug{flex-basis:auto}
._n3tdze3t{padding-bottom:var(--ds-space-0,0)}
._o5721q9c{white-space:nowrap}
._u5f3ze3t{padding-right:var(--ds-space-0,0)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/flag/dist/esm/internal/dismiss-button.compiled.css"],"names":[],"mappings":";AACA,WAAW,iBAAiB,CAAC,WAAW,WAAW;AACnD,WAAW,gCAAgC;AAC3C,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,kBAAkB;AAC7B,WAAW,WAAW;AACtB,WAAW,cAAc;AACzB,WAAW,+BAA+B;AAC1C,WAAW,eAAe;AAC1B,WAAW,kCAAkC;AAC7C,WAAW,kBAAkB;AAC7B,WAAW,iCAAiC","sourcesContent":["\n._1dqoglyw{border-style:none}._16jlidpf{flex-grow:0}\n._19bvze3t{padding-left:var(--ds-space-0,0)}\n._1bah1h6o{justify-content:center}\n._1bsb1tcg{width:24px}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._4cvr1h6o{align-items:center}\n._4t3i1tcg{height:24px}\n._80omtlke{cursor:pointer}\n._ca0qze3t{padding-top:var(--ds-space-0,0)}\n._i0dl1wug{flex-basis:auto}\n._n3tdze3t{padding-bottom:var(--ds-space-0,0)}\n._o5721q9c{white-space:nowrap}\n._u5f3ze3t{padding-right:var(--ds-space-0,0)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
